const revertPriceNumner = (price: string) => {
 if (typeof(price) !== 'string') {
    return price
 }
 return parseFloat(price.replace(/,/g, ''));
}
export default revertPriceNumner;
